<script>
  import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'

  import EditHeader from '../generic/EditHeader.vue'

  export default {
    components: {
      EditHeader
    },
    data () {
      return {
        iconError: faExclamationTriangle
      }
    },
    computed: {
      isLoading () {
        return this.$store.getters[this.store + '/update/isLoading']
      },
      error () {
        return this.$store.getters[this.store + '/update/error']
      },
      item () {
        return this.$store.getters[this.store + '/update/item']
      },
      violations () {
        return this.$store.getters[this.store + '/update/violations']
      },
      translations () {
        return this.translationRoot ? this.translationRoot : this.store.split('/')[0]
      },
    },
    watch: {
      // eslint-disable-next-line object-shorthand,func-names
      deletedItem: function (deleted) {
        if (!deleted) {
          return
        }

        this.$router.push({name: this.listRoute})
      }
    },
    beforeDestroy () {
      this.reset()
    },
    mounted () {
      this.$store.dispatch(this.store + '/update/load', decodeURIComponent(this.$route.params.id))
    },
    methods: {
      reset () {
        this.$store.dispatch(this.store + '/update/reset').then(() => {
          this.$emit('reset')
        })
      },
      onDelete () {
        this.$store.dispatch(this.store + '/del/del', this.item).then(()=> {
          this.$router.go(-1)
        })
      },
      onSendForm () {
        this.$store.dispatch(this.store + '/update/save').then(
          (item) => {
            this.$store.dispatch('toasts/addToast', {
              variant: 'success',
              title: {message: `${this.translations}.toasts.update-success.title`, parameters: {...item}},
              content: {message: `${this.translations}.toasts.update-success.content`, parameters: {...item}},
              hideAfter: 5,
            })
          },
          (error) => {
            this.$store.dispatch('toasts/addToast', {
              variant: 'danger',
              title: {message: `${this.translations}.toasts.update-fail.title`, parameters: {error, ...this.item}},
              content: {message: `${this.translations}.toasts.update-fail.content`, parameters: {error, ...this.item}},
            }, { root: true })
          }
        )
      }
    },
    props: {
      store: {
        type: String,
        required: true
      },
      translationRoot: {
        type: String
      },
      listRoute: {
        type: String,
        required: true
      }
    }
  }
</script>
<template>
  <form @submit.prevent="onSendForm" class="container-fluid" :disabled="isLoading">
    <edit-header :store="store" @delete="onDelete">
    </edit-header>
    <b-row>
      <slot v-bind:store="store + '/update'" v-bind:translationRoot="translations" v-bind:isLoading="isLoading"></slot>
    </b-row>
  </form>
</template>
